module.exports = __webpack_public_path__ + "static/media/dcs004.330bf7a5.png";